import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderControlService {
  public active: boolean;
  public showProgressBar : boolean;
  public manageProceduresActive: boolean = false;

  constructor() { }

}
